import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import r from "../config.js";
import "../geometry.js";
import e from "../request.js";
import o from "../core/Error.js";
import i from "../core/Evented.js";
import { IdentifiableMixin as a } from "../core/Identifiable.js";
import s from "../core/Loadable.js";
import l from "../core/Logger.js";
import { isAbortError as p } from "../core/promiseUtils.js";
import { urlToObject as n } from "../core/urlUtils.js";
import { property as y } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as c } from "../core/accessorSupport/decorators/subclass.js";
import u from "../geometry/Extent.js";
import d from "../geometry/SpatialReference.js";
var m = 0;
var h = l.getLogger("esri.layers.Layer");

var f = /*#__PURE__*/function (_i$EventedMixin) {
  _inherits(f, _i$EventedMixin);

  var _super = _createSuper(f);

  function f() {
    var _this;

    _classCallCheck(this, f);

    _this = _super.apply(this, arguments), _this.attributionDataUrl = null, _this.fullExtent = new u(-180, -90, 180, 90, d.WGS84), _this.id = Date.now().toString(16) + "-layer-" + m++, _this.legendEnabled = !0, _this.listMode = "show", _this.opacity = 1, _this.parent = null, _this.popupEnabled = !0, _this.attributionVisible = !0, _this.spatialReference = d.WGS84, _this.title = null, _this.type = null, _this.url = null, _this.visible = !0;
    return _this;
  }

  _createClass(f, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.when().catch(function (t) {
        var r, e;
        p(t) || l.getLogger(_this2.declaredClass).error("#load()", "Failed to load layer (title: '".concat(null != (r = _this2.title) ? r : "no title", "', id: '").concat(null != (e = _this2.id) ? e : "no id", "')"), {
          error: t
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.parent) {
        var _t = this,
            _r = this.parent;

        "layers" in _r && _r.layers.includes(_t) ? _r.layers.remove(_t) : "tables" in _r && _r.tables.includes(_t) ? _r.tables.remove(_t) : "baseLayers" in _r && _r.baseLayers.includes(_t) ? _r.baseLayers.remove(_t) : "baseLayers" in _r && _r.referenceLayers.includes(_t) && _r.referenceLayers.remove(_t);
      }
    }
  }, {
    key: "hasAttributionData",
    get: function get() {
      return null != this.attributionDataUrl;
    }
  }, {
    key: "parsedUrl",
    get: function get() {
      var t = this.url;
      return t ? n(t) : null;
    }
  }, {
    key: "fetchAttributionData",
    value: function () {
      var _fetchAttributionData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.attributionDataUrl;

                if (!(this.hasAttributionData && t)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return e(t, {
                  query: {
                    f: "json"
                  },
                  responseType: "json"
                });

              case 4:
                return _context.abrupt("return", _context.sent.data);

              case 5:
                throw new o("layer:no-attribution-data", "Layer does not have attribution data");

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchAttributionData() {
        return _fetchAttributionData.apply(this, arguments);
      }

      return fetchAttributionData;
    }()
  }], [{
    key: "fromArcGISServerUrl",
    value: function () {
      var _fromArcGISServerUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var r, e;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                r = "string" == typeof t ? {
                  url: t
                } : t;
                _context2.next = 3;
                return import("./support/arcgisLayers.js");

              case 3:
                e = _context2.sent;
                _context2.prev = 4;
                _context2.next = 7;
                return e.fromUrl(r);

              case 7:
                return _context2.abrupt("return", _context2.sent);

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](4);
                throw h.error("#fromArcGISServerUrl({ url: '" + r.url + "'})", "Failed to create layer from arcgis server url", _context2.t0), _context2.t0;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 10]]);
      }));

      function fromArcGISServerUrl(_x) {
        return _fromArcGISServerUrl.apply(this, arguments);
      }

      return fromArcGISServerUrl;
    }()
  }, {
    key: "fromPortalItem",
    value: function () {
      var _fromPortalItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
        var e, o, _t2, _o, _a;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = "portalItem" in t ? t : {
                  portalItem: t
                };
                _context3.next = 3;
                return import("../portal/support/portalLayers.js");

              case 3:
                o = _context3.sent;
                _context3.prev = 4;
                _context3.next = 7;
                return o.fromItem(e);

              case 7:
                return _context3.abrupt("return", _context3.sent);

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](4);
                _t2 = e && e.portalItem, _o = _t2 && _t2.id || "unset", _a = _t2 && _t2.portal && _t2.portal.url || r.portalUrl;
                throw h.error("#fromPortalItem()", "Failed to create layer from portal item (portal: '" + _a + "', id: '" + _o + "')", _context3.t0), _context3.t0;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 10]]);
      }));

      function fromPortalItem(_x2) {
        return _fromPortalItem.apply(this, arguments);
      }

      return fromPortalItem;
    }()
  }]);

  return f;
}(i.EventedMixin(a(s)));

t([y({
  type: String
})], f.prototype, "attributionDataUrl", void 0), t([y({
  type: u
})], f.prototype, "fullExtent", void 0), t([y({
  readOnly: !0
})], f.prototype, "hasAttributionData", null), t([y({
  type: String
})], f.prototype, "id", void 0), t([y({
  type: Boolean,
  nonNullable: !0
})], f.prototype, "legendEnabled", void 0), t([y({
  type: ["show", "hide", "hide-children"]
})], f.prototype, "listMode", void 0), t([y({
  type: Number,
  range: {
    min: 0,
    max: 1
  },
  nonNullable: !0
})], f.prototype, "opacity", void 0), t([y()], f.prototype, "parent", void 0), t([y({
  readOnly: !0
})], f.prototype, "parsedUrl", null), t([y({
  type: Boolean
})], f.prototype, "popupEnabled", void 0), t([y({
  type: Boolean
})], f.prototype, "attributionVisible", void 0), t([y({
  type: d
})], f.prototype, "spatialReference", void 0), t([y({
  type: String
})], f.prototype, "title", void 0), t([y({
  type: String,
  readOnly: !0,
  json: {
    read: !1
  }
})], f.prototype, "type", void 0), t([y()], f.prototype, "url", void 0), t([y({
  type: Boolean,
  nonNullable: !0
})], f.prototype, "visible", void 0), f = t([c("esri.layers.Layer")], f);
var b = f;
export { b as default };